import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20coral%20and%20amber%20tones%2C%20smooth%20flowing%20curves%2C%20minimalist%20modern%20design%2C%20gentle%20light%20effects%2C%20professional%20corporate%20atmosphere%2C%20clean%20elegant%20aesthetic%2C%20no%20text%2C%20warm%20inviting%20feeling%2C%20subtle%20geometric%20shapes&width=1920&height=600&seq=cta-bg-2026-kaiyun&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/45"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备好体验安全快速的登录服务了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200/90 mb-8 max-w-xl mx-auto">
          立即加入开云登录，与5000万用户一起享受安全、便捷的登录体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 rounded-md text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            免费开始使用
          </Link>
          <Link
            to="/article/kaiyun-denglu-anquan-baohu-zhinan"
            className="px-8 py-3 rounded-md text-base font-medium border border-background-50/50 text-background-50 hover:bg-white/15 transition-all whitespace-nowrap"
          >
            查看安全指南
          </Link>
        </div>
      </div>
    </section>
  );
}